ActionsTemplate from ../templates/actions

Presenter := (player: Player) ->
  Object.assign {}, player,
    length: (l: string) ->
      if arguments.length
        // TODO: Undo stack
        player.song.beatLength(parseFloat(l))
      else
        player.song.beatLength()

export Actions := (player: Player) ->
  element: ActionsTemplate Presenter player

export default Actions
